(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  var burger = document.querySelector('[data-vb-menu-toggle]');
  var mobileMenu = document.querySelector('[data-vb-mobile-menu]');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- Ajax add-to-cart ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-vb-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  document.querySelectorAll('[data-vb-add-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-vb-add-btn]');
      var label = form.querySelector('[data-vb-add-label]');
      var originalText = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Adding…';

      var body = {
        id: form.querySelector('[data-vb-variant-id]').value,
        quantity: 1
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (label) label.textContent = 'Added ✓';
          setTimeout(function () {
            if (btn) btn.disabled = false;
            if (label) label.textContent = originalText;
          }, 1800);
        })
        .catch(function (err) {
          if (label) label.textContent = (err && err.description) || 'Something went wrong';
          if (btn) btn.disabled = false;
          setTimeout(function () {
            if (label) label.textContent = originalText;
          }, 2200);
        });
    });
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-vb-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('vb-main-image');
      if (mainImg) mainImg.src = thumb.getAttribute('data-vb-thumb');
    });
  });
})();
